import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import Button from 'src/component/UI/Button';
import DeviceSelectorField from 'src/component/UI/DeviceSelectorField';
import { useTranslation } from 'src/i18n';
import { COMMISSIONING_TYPES, COMMISSIONING_DEVICE_TYPE_MAP } from './commissioningTypes';

export default function CommissioningTypeSelectDialog (props) {
  const { open, onSelect, onClose } = props;
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState('');
  const [selectedDevice, setSelectedDevice] = useState(null);

  const getDeviceType = (reportType: string) => COMMISSIONING_DEVICE_TYPE_MAP[reportType];

  const handleConfirm = () => {
    if (selectedType) {
      onSelect(selectedType, selectedDevice ? selectedDevice.id : null);
      setSelectedType('');
      setSelectedDevice(null);
    }
  };

  const handleClose = () => {
    setSelectedType('');
    setSelectedDevice(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
      <h2 >{t('commissioning.selectType')}</h2>
      <div>
        <FormControl fullWidth margin='normal'>
          <InputLabel id='commissioning-form-type-label' shrink>{t('commissioning.formType')}</InputLabel>
          <Select
            labelId='commissioning-form-type-label'
            value={selectedType}
            label={t('commissioning.formType')}
            displayEmpty
            onChange={(e) => { setSelectedType(e.target.value); setSelectedDevice(null); }}
          >
            <MenuItem value='' disabled>{t('commissioning.selectReportType')}</MenuItem>
            {COMMISSIONING_TYPES.map(({ value, labelKey }) => (
              <MenuItem key={value} value={value}>{t(labelKey)}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth margin='normal'>
          <DeviceSelectorField
            type={selectedType ? getDeviceType(selectedType) : 'circuitsAndControllers'}
            onChange={setSelectedDevice}
            value={selectedDevice}
          />
        </FormControl>
      </div>
      <div className='button-bar'>
        <Button onClick={handleClose}>{t('common.cancel')}</Button>
        <Button cta onClick={handleConfirm} disabled={!selectedType}>
          {t('common.next')}
        </Button>
      </div>
    </Dialog>
  );
}

CommissioningTypeSelectDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
